export default function About() {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center py-24 px-8">
      <div className="max-w-5xl mx-auto">
        {/* Section Label */}
        <div className="flex justify-center mb-12">
          <div className="inline-block px-6 py-2 border border-gray-300 rounded-full">
            <span className="text-xs uppercase tracking-widest text-gray-600">WHO WE ARE</span>
          </div>
        </div>

        {/* Main Content with Inline Icons */}
        <div className="mb-16">
          <p className="text-5xl font-serif leading-relaxed text-gray-900 text-center">
            We are a dedicated team of experts specializing in{' '}
            <span className="inline-flex items-center justify-center w-16 h-16 mx-2 bg-gradient-to-br from-teal-400 to-teal-600 rounded-2xl shadow-lg align-middle">
              <i className="ri-shield-check-line text-2xl text-white"></i>
            </span>{' '}
            iOS development, creating innovative solutions that prioritize{' '}
            <span className="inline-flex items-center justify-center w-16 h-16 mx-2 bg-gradient-to-br from-orange-400 to-orange-600 rounded-2xl shadow-lg align-middle">
              <i className="ri-rocket-line text-2xl text-white"></i>
            </span>{' '}
            user security and seamless functionality across all{' '}
            <span className="inline-flex items-center justify-center w-16 h-16 mx-2 bg-gradient-to-br from-purple-400 to-purple-600 rounded-2xl shadow-lg align-middle">
              <i className="ri-smartphone-line text-2xl text-white"></i>
            </span>{' '}
            Apple devices.
          </p>
        </div>

        {/* Secondary Content - Three Columns */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16">
          <div className="space-y-3">
            <h3 className="text-lg font-bold text-gray-900">Our Mission</h3>
            <p className="text-base text-gray-600 leading-relaxed">
              To deliver exceptional iOS applications that enhance user experience while maintaining the highest standards of security and performance.
            </p>
          </div>
          <div className="space-y-3">
            <h3 className="text-lg font-bold text-gray-900">Our Approach</h3>
            <p className="text-base text-gray-600 leading-relaxed">
              We combine cutting-edge technology with user-centric design principles to create applications that are both powerful and intuitive.
            </p>
          </div>
          <div className="space-y-3">
            <h3 className="text-lg font-bold text-gray-900">Our Values</h3>
            <p className="text-base text-gray-600 leading-relaxed">
              Innovation, security, and user satisfaction drive everything we do. We are committed to excellence in every line of code.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}